export default {"src":"/_next/static/media/stars.8ecdae0c.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};